export default __webpack_public_path__ + "static/media/PwC_Repre_Illus_Iso_02_IoT_RGB.cc6f5e60.png";